import { render, staticRenderFns } from "./HomePageSpecialPromo.vue?vue&type=template&id=2af564be&scoped=true&"
import script from "./HomePageSpecialPromo.vue?vue&type=script&lang=js&"
export * from "./HomePageSpecialPromo.vue?vue&type=script&lang=js&"
import style0 from "./HomePageSpecialPromo.vue?vue&type=style&index=0&id=2af564be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af564be",
  null
  
)

export default component.exports